import settings from 'lucide-static/icons/settings.svg?raw';
import logOut from 'lucide-static/icons/log-out.svg?raw';
import layoutDashboard from 'lucide-static/icons/layout-dashboard.svg?raw';
import users from 'lucide-static/icons/users.svg?raw';
import calendarDays from 'lucide-static/icons/calendar-days.svg?raw';
import userPlus from 'lucide-static/icons/user-plus.svg?raw';
import userRound from 'lucide-static/icons/user-round.svg?raw';
import penLine from 'lucide-static/icons/pen-line.svg?raw';
import pencil from 'lucide-static/icons/pencil.svg?raw';
import trash2 from 'lucide-static/icons/trash-2.svg?raw';
import search from 'lucide-static/icons/search.svg?raw';
import x from 'lucide-static/icons/x.svg?raw';
import plus from 'lucide-static/icons/plus.svg?raw';
import image from 'lucide-static/icons/image.svg?raw';
import fileText from 'lucide-static/icons/file-text.svg?raw';
import sun from 'lucide-static/icons/sun.svg?raw';
import moon from 'lucide-static/icons/moon.svg?raw';
import monitor from 'lucide-static/icons/monitor.svg?raw';
import mapPin from 'lucide-static/icons/map-pin.svg?raw';
import phone from 'lucide-static/icons/phone.svg?raw';
import mail from 'lucide-static/icons/mail.svg?raw';
import clock from 'lucide-static/icons/clock.svg?raw';
import wrench from 'lucide-static/icons/wrench.svg?raw';
import inbox from 'lucide-static/icons/inbox.svg?raw';
import clipboardList from 'lucide-static/icons/clipboard-list.svg?raw';
import clipboardCheck from 'lucide-static/icons/clipboard-check.svg?raw';
import triangleAlert from 'lucide-static/icons/triangle-alert.svg?raw';
import circleAlert from 'lucide-static/icons/circle-alert.svg?raw';
import circleCheck from 'lucide-static/icons/circle-check.svg?raw';
import camera from 'lucide-static/icons/camera.svg?raw';
import arrowLeft from 'lucide-static/icons/arrow-left.svg?raw';
import chevronLeft from 'lucide-static/icons/chevron-left.svg?raw';
import chevronRight from 'lucide-static/icons/chevron-right.svg?raw';
import buildingIcon from 'lucide-static/icons/building-2.svg?raw';
import undo2 from 'lucide-static/icons/undo-2.svg?raw';
import badgeCheck from 'lucide-static/icons/badge-check.svg?raw';
import loader from 'lucide-static/icons/loader.svg?raw';
import zap from 'lucide-static/icons/zap.svg?raw';
import ticket from 'lucide-static/icons/ticket.svg?raw';
import ban from 'lucide-static/icons/ban.svg?raw';
import check from 'lucide-static/icons/check.svg?raw';

const ICONS = {
  settings,
  'log-out': logOut,
  'layout-dashboard': layoutDashboard,
  users,
  'calendar-days': calendarDays,
  'user-plus': userPlus,
  'user-round': userRound,
  'pen-line': penLine,
  pencil,
  'trash-2': trash2,
  search,
  x,
  plus,
  image,
  'file-text': fileText,
  sun,
  moon,
  monitor,
  'map-pin': mapPin,
  phone,
  mail,
  clock,
  wrench,
  inbox,
  'clipboard-list': clipboardList,
  'clipboard-check': clipboardCheck,
  'triangle-alert': triangleAlert,
  'circle-alert': circleAlert,
  'circle-check': circleCheck,
  camera,
  'arrow-left': arrowLeft,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'building-2': buildingIcon,
  'undo-2': undo2,
  'badge-check': badgeCheck,
  loader,
  zap,
  ticket,
  ban,
  check,
} as const;

export type IconName = keyof typeof ICONS;

interface IconProps {
  name: IconName;
  size?: number;
  class?: string;
  style?: Record<string, string | number>;
}

export function Icon({ name, size = 18, class: className, style }: IconProps) {
  return (
    <span
      class={'icon' + (className ? ' ' + className : '')}
      style={{ width: size, height: size, display: 'inline-flex', flexShrink: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
